import $ from 'jquery';
import React from 'react';
import LoginPopup from '../components/LoginPopup';

export default function LoginPopupRenderer(element) {
  const $element = $(element);
  return <LoginPopup>{$element.html()}</LoginPopup>;
}
